import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useQueryParamsObject = () => {
    const { search } = useLocation();
    const [queryParams, setQueryParams] = useState({});

    useEffect(() => {
        const params = new URLSearchParams(search);
        const allParams: any = {};
        Array.from(params.entries()).forEach(([key, value]) => {
            allParams[key] = value;
        });
        setQueryParams(allParams);
    }, [search]);

    return queryParams;
};

export default useQueryParamsObject;
